import axios from 'axios'
import { Constants } from '../common'
import { signOutClerkSession } from './clerkSession'

const STORAGE_KEYS = {
  user: 'user',
}

const ADMIN_CSRF_COOKIE = 'ob_admin_csrf'
const ADMIN_CSRF_HEADER = 'x-admin-csrf-token'

const readCookie = (name) => {
  if (typeof document === 'undefined') return ''

  const prefix = `${name}=`
  const parts = document.cookie.split(';')
  for (const part of parts) {
    const trimmed = part.trim()
    if (trimmed.startsWith(prefix)) {
      return decodeURIComponent(trimmed.slice(prefix.length))
    }
  }

  return ''
}

export const loadAuthTokens = () => null

export const saveAuthTokens = () => null

export const getAccessToken = () => ''

export const getCsrfToken = () => readCookie(ADMIN_CSRF_COOKIE)

export const getCsrfHeaders = () => {
  const csrfToken = getCsrfToken()
  return csrfToken ? { [ADMIN_CSRF_HEADER]: csrfToken } : {}
}

export const getStoredUser = () => {
  const raw = localStorage.getItem(STORAGE_KEYS.user)
  if (!raw || raw === 'null') return null

  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export const setStoredUser = (user) => {
  if (!user) {
    localStorage.removeItem(STORAGE_KEYS.user)
    return
  }

  localStorage.setItem(STORAGE_KEYS.user, JSON.stringify(user))
}

export const hasSessionHint = () => true

export const clearAuthTokens = () => {
  localStorage.removeItem(STORAGE_KEYS.user)
  void signOutClerkSession().catch(() => undefined)

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('onebody:auth:logout'))
  }
}

let inFlightRefresh = null

export const refreshAuthTokens = async () => {
  if (inFlightRefresh) return inFlightRefresh

  inFlightRefresh = (async () => {
    try {
      await axios.post(
        `${Constants.API_URL}/admin/auth/refresh`,
        {},
        {
          withCredentials: true,
          headers: getCsrfHeaders(),
        },
      )
      return true
    } catch {
      clearAuthTokens()
      return null
    } finally {
      inFlightRefresh = null
    }
  })()

  return inFlightRefresh
}
